var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13691_10170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66671 3.33301H7.95631C9.9878 3.33301 11.0036 3.33301 11.3891 3.69787C11.7224 4.01325 11.8701 4.47786 11.7802 4.92782C11.676 5.44835 10.8468 6.03491 9.18823 7.20803L6.47852 9.12465C4.81998 10.2978 3.9907 10.8843 3.8866 11.4049C3.79661 11.8548 3.94432 12.3194 4.27762 12.6348C4.6632 12.9997 5.67895 12.9997 7.71044 12.9997H8.33337M5.33337 3.33301C5.33337 4.43758 4.43794 5.33301 3.33337 5.33301C2.2288 5.33301 1.33337 4.43758 1.33337 3.33301C1.33337 2.22844 2.2288 1.33301 3.33337 1.33301C4.43794 1.33301 5.33337 2.22844 5.33337 3.33301ZM14.6667 12.6663C14.6667 13.7709 13.7713 14.6663 12.6667 14.6663C11.5621 14.6663 10.6667 13.7709 10.6667 12.6663C10.6667 11.5618 11.5621 10.6663 12.6667 10.6663C13.7713 10.6663 14.6667 11.5618 14.6667 12.6663Z",
    stroke: "#165AE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13691_10170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.e1b80e6b35df3af97e50e25aa8046ea7.svg";
export { ForwardRef as ReactComponent };